import React from 'react';

const QuoteIcon = props => (
  <svg viewBox="0 0 15.031 13.031" style={{ fillRule: 'evenodd' }} {...props}>
    <path
      stroke="none"
      d="M299.858,70.44a14.6,14.6,0,0,1-.492,3.785,6.812,6.812,0,0,1-1.888,2.951,9.271,9.271,0,0,1-2.737,1.769,0.825,0.825,0,0,1-1.072-.4l-0.59-1.234a0.813,0.813,0,0,1,.408-1.092,4.945,4.945,0,0,0,2.056-1.528,4.56,4.56,0,0,0,.733-1.715A3.544,3.544,0,1,1,299.858,70.44Zm-8.492,3.785a6.826,6.826,0,0,1-1.886,2.951,9.339,9.339,0,0,1-2.74,1.769,0.824,0.824,0,0,1-1.07-.4l-0.592-1.234a0.812,0.812,0,0,1,.409-1.092,4.925,4.925,0,0,0,2.054-1.528,4.452,4.452,0,0,0,.734-1.715,3.544,3.544,0,1,1,3.581-2.537A14.566,14.566,0,0,1,291.366,74.225Z"
      transform="translate(-284.969 -66)"
    />
  </svg>
);

export default QuoteIcon;



// WEBPACK FOOTER //
// ./app/components/text-editor/icons/quote-icon.js